import { Stack, Shimmer, Label } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

/**
 * UI for rendering the CWE field on the CVE details page's title card.
 * Note: This is currently as a back up to the cweDetailsListValue component.
 */
export const CweList = ({
  cweValue,
  loading,
}: {
  cweValue?: string[];
  loading?: boolean;
}) => {
  const [t] = useTranslation(['vulnerability']);

  if (cweValue === undefined || cweValue === null || cweValue?.length < 1)
    return null;

  const isMultiple = cweValue?.length > 1;

  const parentLabel = t('cweWeaknesses.weakness', {
    defaultValue: 'Weakness',
    ns: 'vulnerability',
  });

  return (
    <dl
      style={{
        // Render vertically if there are multiple CWEs
        ...(isMultiple && {
          marginTop: '1em',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }),
      }}
    >
      <dt>{parentLabel}</dt>
      <dd>
        <Shimmer styles={{ root: { minWidth: '8em' } }} isDataLoaded={!loading}>
          {isMultiple ? (
            <ol style={{ paddingLeft: '14px', marginBottom: '0px' }}>
              {cweValue?.map((cwe, index) => (
                <li key={index} style={{ paddingBottom: '1rem' }}>
                  {cwe}
                </li>
              ))}
            </ol>
          ) : (
            <div style={{ paddingLeft: '4px' }}>{cweValue[0]}</div>
          )}
        </Shimmer>
      </dd>
    </dl>
  );
};
